import { get, put } from 'utils/RequestV2';
import API_CONSTANT from 'constants/apiConstant';

export const fetchLenderUpgradeDetails = async () => get('v1/' + API_CONSTANT.URL.LENDER_UPGRADE_DETAILS);
export const initiateLenderUpgrade = async (payload) => put('v1/' + API_CONSTANT.URL.INITIATE_LENDER_UPGRADE, payload);
